module.exports = __webpack_public_path__ + "static/media/26UNRWA11.5fcefa07.jpg";